import React, { useMemo } from "react";
import { Dropdown, DropdownListItem } from "cerulean";

import Account from "byzantine/src/Account";
import { useLocalization } from "@fluent/react";

interface AccountSelectorProps {
  accounts: Account[];
  onChange: (accountId: string[]) => void;
  value: string[] | undefined;
  error?: string;
  errorText?: string;
}

const AccountSelector = ({
  accounts,
  onChange,
  value,
  error,
  errorText,
}: AccountSelectorProps) => {
  const { l10n } = useLocalization();
  const displayValue = useMemo(() => {
    if (!value) return "";

    const selectedAccount = accounts.filter((account) =>
      value.includes(account.id)
    );

    if (selectedAccount.length > 1) {
      return l10n.getString(
        "custom-alerts-select-label-select-all",
        {},
        "All accounts selected"
      );
    } else if (selectedAccount.length === 1) {
      return selectedAccount[0].getDescription();
    }
    return "";
  }, [l10n, value, accounts]);

  return (
    <Dropdown
      triggerLabel={l10n.getString(
        "custom-alerts-form-label-account",
        {},
        "Account name"
      )}
      triggerValue={displayValue}
      error={error || errorText}
    >
      <div className="margin--s" />
      <DropdownListItem
        key={"select-all"}
        anyItemSelected={value && value.length > 0}
        isSelected={value && value.length === accounts.length}
        onClick={() => onChange(accounts.map((account) => account.id))}
      >
        {l10n.getString(
          "custom-alerts-select-option-select-all",
          {},
          "Select all"
        )}
      </DropdownListItem>
      {accounts.map((account) => (
        <DropdownListItem
          key={account.id}
          anyItemSelected={value && value.length > 0}
          isSelected={value && value.includes(account.id)}
          onClick={() => onChange([account.id])}
        >
          {account.getDescription()}
        </DropdownListItem>
      ))}
    </Dropdown>
  );
};

export default AccountSelector;
